import Cookies from "js-cookie";

export const NEXT_LOCALE_COOKIE = "NEXT_LOCALE";

export const setNextLocaleCookieTo = (locale: string) => {
  Cookies.set(NEXT_LOCALE_COOKIE, locale, { SameSite: "None", secure: true });
};
